import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiDocument\DownloadBlankWikiDocumentController::__invoke
* @see app/Http/Controllers/WikiDocument/DownloadBlankWikiDocumentController.php
* @route '/api/wiki-document/{wiki_document}/download-blank'
*/
const DownloadBlankWikiDocumentController = (args: { wiki_document: number | { id: number } } | [wiki_document: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DownloadBlankWikiDocumentController.url(args, options),
    method: 'get',
})

DownloadBlankWikiDocumentController.definition = {
    methods: ["get","head"],
    url: '/api/wiki-document/{wiki_document}/download-blank',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiDocument\DownloadBlankWikiDocumentController::__invoke
* @see app/Http/Controllers/WikiDocument/DownloadBlankWikiDocumentController.php
* @route '/api/wiki-document/{wiki_document}/download-blank'
*/
DownloadBlankWikiDocumentController.url = (args: { wiki_document: number | { id: number } } | [wiki_document: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_document: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_document: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_document: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_document: typeof args.wiki_document === 'object'
        ? args.wiki_document.id
        : args.wiki_document,
    }

    return DownloadBlankWikiDocumentController.definition.url
            .replace('{wiki_document}', parsedArgs.wiki_document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiDocument\DownloadBlankWikiDocumentController::__invoke
* @see app/Http/Controllers/WikiDocument/DownloadBlankWikiDocumentController.php
* @route '/api/wiki-document/{wiki_document}/download-blank'
*/
DownloadBlankWikiDocumentController.get = (args: { wiki_document: number | { id: number } } | [wiki_document: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: DownloadBlankWikiDocumentController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiDocument\DownloadBlankWikiDocumentController::__invoke
* @see app/Http/Controllers/WikiDocument/DownloadBlankWikiDocumentController.php
* @route '/api/wiki-document/{wiki_document}/download-blank'
*/
DownloadBlankWikiDocumentController.head = (args: { wiki_document: number | { id: number } } | [wiki_document: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: DownloadBlankWikiDocumentController.url(args, options),
    method: 'head',
})

export default DownloadBlankWikiDocumentController